import TableNoDataComponent from './tableNoDataComponent';

export default TableNoDataComponent;
